// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"f28827a2","680":"04cf035f","900":"c4ef53df"}[chunkId] + ".chunk.js";
};